module.exports = __webpack_public_path__ + "static/media/c3_1.6c4dfd50.png";